import { render, staticRenderFns } from "./ControlTab.vue?vue&type=template&id=d46e2574&scoped=true&"
import script from "./ControlTab.vue?vue&type=script&lang=ts&"
export * from "./ControlTab.vue?vue&type=script&lang=ts&"
import style0 from "./ControlTab.vue?vue&type=style&index=0&id=d46e2574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46e2574",
  null
  
)

export default component.exports